import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const cardNumberInputStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.tiny,
  } as CSSProperties,

  label: {
    display: 'block',
    fontFamily: theme.typography.fontFamily,
    color: theme.colors.label,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: theme.typography.lineHeight.sm,
    letterSpacing: 'normal',
    margin: 0,
  } as CSSProperties,

  input: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${theme.spacing.mediumSmall}px ${theme.spacing.small}px`,
    height: 36,
    // Longhand (no `border`): el modificador de foco/error pisa `borderColor` sin mezclar propiedades.
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.colors.inputBorder,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.inputBg,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: theme.typography.lineHeight.base,
    color: theme.colors.inputText,
    outline: 'none',
  } as CSSProperties,

  inputFocus: {
    outline: 'none',
    borderColor: theme.colors.button.primary,
    boxShadow: `0 0 0 2px ${theme.colors.palette.blue160}`,
  } as CSSProperties,

  inputComplete: {
    borderColor: theme.colors.palette.grey650,
  } as CSSProperties,
};
